import React from "react"
import { TextField } from "@material-ui/core"

interface IProps {
  input: {
    onChange: (value: string) => {}
    value: string
    onBlur: (value: string) => {}
  }
  meta: { touched: boolean; error: string }
  onChange: (value: string) => {}
  name: string
  floatingLabelText?: string
  floatingLabelStyle?: React.CSSProperties
}

const MuiSelectField = (props: IProps) => {
  const {
    input: { onChange, value, onBlur, ...inputProps },
    meta: { touched, error },
    onChange: onChangeFromField,
    floatingLabelText,
    floatingLabelStyle,
    ...rest
  } = props
  return (
    <TextField
      select
      {...inputProps}
      label={floatingLabelText}
      InputLabelProps={{ style: floatingLabelStyle }}
      value={value}
      error={touched && !!error}
      helperText={touched && error}
      onChange={(event) => {
        onChange(event.target.value)
        if (onChangeFromField) {
          onChangeFromField(event.target.value)
        }
      }}
      onBlur={() => onBlur(value)}
      {...rest}
    />
  )
}

export default MuiSelectField
